import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Button, Checkbox, Label, ModalDelete } from "expano-components";
import { Dashboard } from "components";
import useDelete from "hooks/useDelete";
import { client, getApiErrorMessage } from "utils/api";

const ChannelProducts = ({
  platform_type,
  is_bundle,
  is_virtual,
  data,
  refetch,
}) => {
  const [channel_product_to_delete, setChannelProductToDelete] = useState(null);
  const [saving_id, setSavingId] = useState(null);
  const [reset_key, setResetKey] = useState(0);
  const { is_deleting, _delete } = useDelete({
    path: `/channel_products/${channel_product_to_delete?.id}`,
  });

  const toggleShippingPrice = async (id, include_channel_shipping_price) => {
    try {
      setSavingId(id);
      await client.patch(
        `/channel_products/${id}/update_include_channel_shipping_price`,
        { include_channel_shipping_price }
      );
      toastr.success("Sukces", "Zaktualizowano pomyślnie");
      refetch();
    } catch (error) {
      toastr.error("Błąd", getApiErrorMessage(error));
      setResetKey((key) => key + 1);
    } finally {
      setSavingId(null);
    }
  };

  const handleDelete = async () => {
    await _delete();
    refetch();
    setChannelProductToDelete(null);
  };

  return (
    <Dashboard
      header={{
        icon: "channel",
        title: `Kanały ${platform_type.split("::")[0]}`,
      }}
    >
      {channel_product_to_delete?.id && (
        <ModalDelete
          name={`przypisanie produktu do kanału ${channel_product_to_delete?.identifier}?`}
          handleDelete={handleDelete}
          handleClose={() => setChannelProductToDelete(null)}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, is_brand_channel, include_channel_shipping_price, channel }) => {
              const can_delete =
                !is_brand_channel ||
                (is_bundle && channel.ignore_bundle_products) ||
                (is_virtual && channel.ignore_virtual_products);
              const shipping_price = channel?.additional_channel_shipping_price ?? 0;
              const currency = channel?.platform?.currency_code;
              return (
                <tr key={id}>
                  <td>
                    <Label
                      type="double"
                      left={{
                        text: channel?.shop?.label_text,
                        color: `#${channel?.shop?.label_color}`,
                      }}
                      right={{
                        text: channel?.platform?.label_text,
                        color: `#${channel?.platform?.label_color}`,
                      }}
                    />
                    {channel?.identifier}
                    {!is_brand_channel && (
                      <span className="tag tag--danger m-l-10">
                        Spoza marki
                      </span>
                    )}
                    {is_bundle && channel.ignore_bundle_products && (
                      <span className="tag tag--danger m-l-5">Bundle</span>
                    )}
                    {is_virtual && channel.ignore_virtual_products && (
                      <span className="tag tag--danger m-l-5">
                        Produkt wirtualny
                      </span>
                    )}
                    {Number(shipping_price) > 0 && (
                      <Checkbox
                        key={`${id}-${include_channel_shipping_price}-${reset_key}`}
                        label={`Uwzględniaj cenę wysyłki w cenie produktu (${shipping_price}${
                          currency ? ` ${currency}` : ""
                        })`}
                        disabled={saving_id === id}
                        meta={{}}
                        input={{
                          name: `include_channel_shipping_price_${id}`,
                          value: !!include_channel_shipping_price,
                          onChange: (event) =>
                            toggleShippingPrice(id, event.target.checked),
                        }}
                      />
                    )}
                  </td>
                  <td width={80}>
                    {can_delete && (
                      <Button
                        disabled={is_deleting}
                        type="delete-bin"
                        onClick={() =>
                          setChannelProductToDelete({
                            id,
                            identifier: channel?.identifier,
                          })
                        }
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default ChannelProducts;
